import React from 'react';
import classNames from 'classnames';

import css from './AiToolTimeline.module.css';

const AiToolTimeline = ({
  steps = [],
  className,
  ariaLabel = 'AI tool progress',
  dataTestId,
}) => {
  if (!Array.isArray(steps) || steps.length === 0) {
    return null;
  }

  return (
    <div
      className={classNames(css.root, className)}
      aria-label={ariaLabel}
      aria-live="polite"
      data-testid={dataTestId}
    >
      {steps.map(step => (
        <span
          key={step.tool}
          className={classNames(css.chip, {
            [css.chipActive]: step.status === 'active',
            [css.chipComplete]: step.status !== 'active',
          })}
        >
          <span className={css.indicator} aria-hidden="true" />
          <span className={css.label}>{step.label}</span>
        </span>
      ))}
    </div>
  );
};

export default AiToolTimeline;
